{
    "error": "Error",
    "table_column_view": {
        "save": {
            "title": "Could not save view"
        }
    },
    "unknown": "An unknown error occurred. Please try again later.",
    "timeout": "The request could not be completed at the moment. Please try again later.",
    "unavailable": "You are either offline or our servers are currently unavailable. Please try again later.",
    "unauthorized_action": "You are not authorized to perform this action.",
    "internal_server": "An internal server error occurred. Please try again later.",
    "already_exists": "There is a conflict since the resource probably already exists.",
    "parallel_editing": "This resource has already been modified by someone else. Please reload the page and apply your changes again.",
    "login": {
        "title": "Login failed!",
        "message_unauthorized": "Your username or password is incorrect.",
        "message_forbidden": "Your account has been suspended.",
        "clear_cookies": "Clear your cookies"
    },
    "auth": {
        "title": "Warning",
        "not_authenticated": "Not authenticated.",
        "account_suspended": "Your account has been suspended."
    },
    "form": {
        "title": "Form error",
        "message": "Some fields contain invalid input.",
        "not_all_fields_filled": "Not all required fields are filled. Please fill out all required inputs and try again.",
        "amount_error": "Amount does not match."
    },
    "password": {
        "title": "Password change failed",
        "message": "Password could not be changed."
    },
    "bug_report": {
        "title": "Error",
        "message": "Failed to send bug report."
    },
    "request": {
        "create": {
            "title": "Request submit failed"
        },
        "approval_process_submit": {
            "title": "Submission failed"
        },
        "edit": {
            "title": "Edit failed"
        },
        "cancel": {
            "title": "Cancel failed"
        },
        "approved": {
            "title": "Approve failed"
        },
        "reviewed": {
            "title": "Review failed"
        },
        "paid": {
            "title": "Payment failed"
        },
        "exported": {
            "title": "Export failed"
        },
        "rejected": {
            "title": "Reject failed",
            "message": "Failed to reject the request."
        },
        "request_changes": {
            "title": "Requesting changes failed"
        },
        "reject_folder": {
            "title": "Empty folder cannot be rejected"
        },
        "send_reminder": {
            "title": "Sending failed"
        },
        "payment": {
            "title": "Payment processing failed"
        },
        "not_found": {
            "title": "Object not found",
            "message": "The requested Object not found"
        },
        "tax": {
            "title": "Tax update failed"
        },
        "fetch": {
            "title": "Update failed",
            "message": "Failed to update expense list."
        },
        "reset": {
            "cannot_reset_purchase_request": {
                "title": "Error",
                "message": "Cannot reset a purchase request."
            },
            "cannot_reset_processed_request": {
                "title": "Error",
                "message": "Cannot reset an already fully processed request."
            },
            "cannot_reset_card_request": {
                "title": "Error",
                "message": "Cannot reset a card request."
            }
        },
        "restore": {
            "title": "Error"
        },
        "sepa": {
            "title": "Export failed",
            "message": "Failed to generate SEPA XML."
        },
        "archived": {
            "title": "Error"
        },
        "opos_excluded": {
            "title": "Error",
            "message": "Failed to clear item from open items list"
        },
        "opos_included": {
            "title": "Error",
            "message": "The item could not be included again in the open items list"
        },
        "opos_included_bulk": {
            "title": "Error",
            "message": "The items could not be included again in the open items list"
        },
        "follow_up": {
            "title": "Error",
            "message": "Failed to update the follow-up field"
        },
        "missing_field": {
            "must_be_added": "Must be added before you can continue.",
            "must_be_adjusted": "Must be adjusted before you can continue."
        }
    },
    "file": {
        "upload": {
            "title": "Error",
            "message": "File upload failed."
        },
        "duplicates": {
            "title": "Warning",
            "message": "Duplicates are not allowed."
        },
        "delete": {
            "title": "Error",
            "message": "File delete failed."
        },
        "export": {
            "title": "Error",
            "message": "Export failed."
        },
        "export_no_data": {
            "title": "Warning",
            "message": "No data found for the given query."
        },
        "loading": {
            "title": "Error",
            "message": "Some files failed to load."
        },
        "too_big": {
            "title": "Error",
            "message": "File is exceeding 10 MB. Please upload a smaller file."
        },
        "too_many_invoices": {
            "title": "Error",
            "message": "Due to DATEV limitation you can not upload more than 50 files to one expense."
        },
        "not_all_exported": {
            "title": "Warning",
            "message": "Not all expenses were exported."
        },
        "duo_wrong_import_target": {
            "title": "Error",
            "message": "DUO export for at least one request failed because the accounting month is not configured in your linked DUO account."
        },
        "download": {
            "title": "Error",
            "message": "Your download failed."
        },
        "unsupported_file_type": {
            "title": "Error",
            "message": "You are trying to upload an unsupported file format. Please try another invoice file format e.g. {{allowedFormats}}"
        }
    },
    "comment": {
        "save": {
            "title": "Error",
            "message": "Failed to save comment."
        },
        "update": {
            "title": "Error",
            "message": "Failed to update comment."
        },
        "delete": {
            "title": "Error",
            "message": "Failed to delete comment."
        }
    },
    "subscription": {
        "delete": {
            "title": "Error",
            "message": "Failed to delete subscription."
        }
    },
    "transaction": {
        "delete": {
            "title": "Error",
            "message": "Failed to delete transaction."
        },
        "bulk_delete": {
            "title": "Error",
            "message": "Failed to delete transactions."
        },
        "update_category": {
            "title": "Error",
            "message": "Failed to update transaction category."
        }
    },
    "vendor": {
        "create": {
            "title": "Vendor submit failed"
        },
        "edit": {
            "title": "Edit failed"
        },
        "delete": {
            "title": "Error",
            "message": "Failed to delete vendor."
        },
        "incompatible_creditor_number": "Incompatible with DATEV"
    },
    "cost_center": {
        "create": {
            "title": "Cost center 1 submit failed"
        },
        "edit": {
            "title": "Edit failed"
        },
        "delete": {
            "title": "Error",
            "message": "Failed to delete cost center 1."
        }
    },
    "employee": {
        "create": {
            "title": "Employee submit failed"
        },
        "edit": {
            "title": "Edit failed"
        },
        "delete": {
            "title": "Error",
            "message": "Failed to delete employee."
        },
        "possible_approvers": {
            "title": "Error",
            "message": "Failed to load any possible approvers."
        },
        "exists": "Employee already exists",
        "invite": {
            "title": "Employee invite"
        },
        "missing": "Employee missing.",
        "no_creditor_number": {
            "title": "Creditor number missing",
            "message": "Please add a creditor number for this employee before marking the request as reviewed"
        },
        "creditor_number_unsynced": {
            "title": "Creditor data in request differs from employee profile",
            "message": "The creditor data in this request differs from the creditor data in the employee profile. Please synchronize the data to ensure accurate reimbursement processing."
        }
    },
    "employee_absence": {
        "update": {
            "title": "Update failed"
        }
    },
    "settings": {
        "edit": {
            "title": "Edit failed",
            "messge": "Failed to update settings."
        }
    },
    "reset_password": {
        "title": "Sorry, this token is not valid.",
        "message": "Please click on the link that you have received in your email to reset your password."
    },
    "verify_email": {
        "title": "Sorry, this token is not valid.",
        "message": "Please click on the link that you have received in your email to confirm your new email address."
    },
    "offline": {
        "title": "Network Error",
        "message": "It seems like you are offline. Please refresh the page to try again."
    },
    "payment_subscription": {
        "general": {
            "title": "Error",
            "message": "An error occurred."
        },
        "failed": {
            "title": "Error",
            "message": "Your payment failed. Please try again."
        },
        "cancel": {
            "title": "Error",
            "message": "Failed to cancel the payment subscription."
        },
        "reactivate": {
            "title": "Error",
            "message": "Failed to reactivate the payment subscription."
        },
        "delete": {
            "title": "Error",
            "message": "Failed to delete the payment subscription."
        },
        "missing_card": {
            "title": "Error",
            "message": "Please fill out the card details."
        },
        "invalid_card": {
            "title": "Error",
            "message": "Card input is invalid."
        },
        "inv_download": {
            "title": "Error",
            "message": "Failed to download the latest invoice."
        },
        "update": {
            "title": "Error",
            "message": "Failed to update the payment subscription."
        },
        "create": {
            "title": "Error",
            "message": "Failed to create the payment subscription."
        },
        "failed_payment": "Authentication for this card failed."
    },
    "csv_matching": {
        "title": "Error",
        "process": "Failed to process CSV.",
        "no_emails": "The CSV file contains no email addresses, please be sure to only upload email addresses.",
        "no_new_emails": "The CSV file contains no new email addresses, please be sure to upload email addresses that you haven't already added to the input field."
    },
    "matching": {
        "title": "Error",
        "perform": {
            "title": "Error",
            "message": "Failed to perform matching."
        },
        "determine": {
            "title": "Error",
            "message": "Failed to determine matching options.",
            "no_transactions_found": {
                "title": "Error",
                "message": "No new transactions created."
            }
        },
        "already_in_possible_matches": "Expense already listed as possible expense.",
        "expense_has_already_transaction_set": "This expense is already matched to another transaction.",
        "cannot_manually_match_or_unmatch_card_transaction": "Cannot manually match or un-match card transaction",
        "cannot_match_card_expense_manually": "Cannot match an expense with a card manually",
        "no_date_or_amount_column_found": "Cannot perform matching without a date and amount column to be found."
    },
    "banking": {
        "error": "Banking Error",
        "bank_rejected_payment": "Bank rejected payment.",
        "account_does_not_support_payment": "Your bank account does not support SEPA online payments.",
        "expense_already_in_payment_process": "This expense is already in a payment process. If you started the payment, please finish the web form that was opened. If nothing opened, please check your browser popup settings. The web-form will expire in 10 minutes and the process can be restarted.",
        "missing_vendor_data": "Selected vendor is missing IBAN or BIC.",
        "missing_requester_data": "Selected requester is missing IBAN or BIC for reimbursement.",
        "webform_failed": "Webform validation failed.",
        "delete": {
            "title": "Banking Error",
            "message": "Failed to delete bank connection."
        },
        "has_to_be_default": "Account has to be the default connection since no other account exists.",
        "no_supported_interface": "Bank does not support any of the required online interfaces.",
        "account": {
            "delete": {
                "title": "Error",
                "message": "Failed to delete bank account."
            },
            "cannot_delete_default": {
                "title": "Warning",
                "message": "Cannot delete default account."
            }
        },
        "import": {
            "title": "Error",
            "message": "Bank import failed. Please try again.",
            "message_with_reason": "Bank reject request with message: \"{{message}}\". Please contact support and forward this error, so we can help identifying the problem.",
            "conflict": {
                "title": "Error",
                "message": "Bank import failed - this bank is already imported."
            }
        },
        "new_interface_added": {
            "title": "Error",
            "message": "Failed to add new interface. Please try again."
        },
        "payment": {
            "title": "Error",
            "message": "Failed to issue payment. Please try again."
        },
        "webform_abort": {
            "title": "Warning",
            "message": "Banking web-form aborted or expired. Please start over."
        },
        "download": {
            "title": "Error",
            "message": "Failed to download transactions or timed out. Please try to delete and re-import the bank connection."
        },
        "sepa_generation_missing_company_iban_or_bic": "Company IBAN and BIC in the company settings are required for SEPA XML generation",
        "refresh_payment_status": {
            "title": "Error",
            "message": "Failed to update payment status."
        }
    },
    "expense_account": {
        "update": {
            "title": "Error"
        },
        "incompatible": {
            "title": "Error",
            "message": "Expense account is incompatible."
        }
    },
    "cost_center_2": {
        "update": {
            "title": "Error"
        }
    },
    "stripe": {
        "connection_error": "Failed to connect the payment server. Please check your Internet connection.",
        "insufficient_funds": "Your card has insufficient funds",
        "authentication_failure": "Authentication for this card failed, please try another one.",
        "incomplete_number": "Your card number is incomplete.",
        "invalid_number": "Your card number is invalid.",
        "incomplete_expiry": "Your card's expiration date is incomplete.",
        "invalid_expiry_year_past": "Your card's expiration year is in the past.",
        "invalid_expiry_month_past": "Your card's expiration month is in the past.",
        "incomplete_cvc": "Your card's security code is incomplete.",
        "incomplete_zip": "Your postal code is incomplete."
    },
    "loader": {
        "title": "Loader Error",
        "message": "Failed to load initial data. Please contact the support team."
    },
    "expense_filter": {
        "updated": "Error"
    },
    "fetch": {
        "title": "Refresh Error",
        "message": "Failed to update data."
    },
    "ocr": {
        "title": "OCR error",
        "message": "Failed to extract data from the PDF automatically.",
        "failed_to_update_expense": "Failed to update expense with OCR data from invoice.",
        "select_ocr_source": "Please select an OCR source.",
        "still_processing": "Invoice is still processing. Try again once the OCR run is completed."
    },
    "einvoice": {
        "title": "E-Invoice Error"
    },
    "notifications": {
        "title": "Object not found",
        "message": "Object may have been deleted."
    },
    "invoice_inbox": {
        "delete": {
            "title": "Error"
        },
        "move": { "title": "Invoice move failed" },
        "assign": { "title": "Employee assign failed" },
        "unassign": { "title": "Employee unassign failed" },
        "change_document_type": { "title": "Changing document type failed" }
    },
    "cards": {
        "kyb": {
            "start": {
                "title": "Error"
            },
            "update": {
                "title": "Error"
            },
            "duplicate_email": "Duplicate email for director and shareholder"
        },
        "create": {
            "title": "Error",
            "phone_number_not_verified": "Selected employee needs to have his phone number verified to be a card holder.",
            "user_not_enrolled": "User is not enrolled in the cards program yet.",
            "failed": "Failed to create card. Please try again or contact our support team."
        },
        "update_status": {
            "title": "Update failed"
        },
        "edit": {
            "title": "Update failed"
        },
        "something_went_wrong": "Something went wrong with this card, please contact our support team",
        "not_enough_funds": "Business wallet does not have enough funds.",
        "topup": {
            "title": "Failed to top up card."
        },
        "expense_card_creation": "Failed to create a card for this expense. Please try again or contact support.",
        "top_up": {
            "must_be_active": "Card must be active in order to top it up."
        },
        "wrong_pin": "PIN is incorrect.",
        "wrong_verification_code": "Verification code is incorrect.",
        "already_used_email": "This email has already been used before.",
        "frequency_exceeded": "This operation has been executed too often cannot be repeated again for now.",
        "not_enrolled_for_request": "For smart card requests, the requester needs to be enrolled in the cards program.",
        "physical_card_upgrade": {
            "title": "Warning",
            "message": "Physical card was issued but a problem occurred. You can find more information on the card detail page for this card."
        },
        "auto_approver_for_card_request": "Auto approver cannot be selected for smart card requests.",
        "auto_approver_limit_exceeded": "This value exceeds the auto-approver's limit.",
        "card_or_matched_request_cannot_be_deleted": "A request with a smart card or that is matched to a transaction cannot be rejected.",
        "sub_card_only_eur": "Card can only be issued for subscriptions that use EUR as their currency",
        "phyiscal_disabled": "Physical cards are currently disabled but coming soon. Please check in with our support team to get to know when they will be enabled.",
        "not_allowed_in_demo": "This action is not possible in a demo.",
        "cannot_change_requester_with_card_attachted": "Cannot change the requester if there is a card already attached to the request.",
        "account_statement_download": "Failed to download the account statement.",
        "new_smart_card_subs_cannot_start_in_past": "A new smart card subscription cannot start in the past.",
        "limit_change_request": "Card limit change request failed.",
        "card_program_onboarding_not_finished": {
            "title": "Error",
            "message": "You have to fully be on-boarded into the cards program before you can perform this action."
        },
        "step_up_token": {
            "title": "Error",
            "message": "Your action is not allowed. Please check that your mobile number is enrolled in the cards program."
        },
        "weavr_error": {
            "title": "Fehler",
            "message": "Beim Laden der Kreditkartendaten ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal."
        }
    },
    "corporate": {
        "setup_user_passcode": {
            "title": "Error",
            "message": "Failed to create pincode. Please try again or contact our support."
        },
        "verify_email": {
            "title": "Error",
            "message": "Failed to verify email address."
        },
        "email_verification_code": {
            "title": "Error",
            "message": "Failed to request verification code."
        },
        "verify_mobile": {
            "title": "Error",
            "message": "Failed to verify mobile number."
        },
        "mobile_verification_code": {
            "title": "Error",
            "message": "Failed to request verification code."
        },
        "enroll_user": {
            "title": "Error",
            "message": "Failed to enroll user into cards program."
        },
        "account_create": {
            "title": "Error",
            "message": "Business account could not be created."
        },
        "company_details_submit": {
            "title": "Error",
            "message": "Failed to submit company details."
        },
        "no_password": "This user does not have a finway PIN yet. Please finish the onboarding for the card program to create a finway PIN.",
        "weavr_step_up_required": "You have to finish the onboarding into the cards program before you can perform this action.",
        "authentication_expired": "Your authentication attempt is expired. Please try again.",
        "cannot_be_performed_due_to_cards_enrollment_in_other_company": "This action cannot be performed due to a dependency to another card program."
    },
    "wallet": {
        "wire_send": {
            "title": "Error",
            "message": "Transfer could not be started."
        }
    },
    "passcode": {
        "recovery": {
            "wrong_passcode": {
                "title": "Error",
                "message": "Old finway PIN is incorrect."
            }
        }
    },
    "payment_failed": {
        "message": "Payment was not successful.",
        "description": "Reason given by your bank: {{message}} Please try to perform the payment again.",
        "none": "none.",
        "tag": "Payment failed"
    },
    "workflow": {
        "no_appropriate_workflow_rule_found": "No appropriate workflow rule was found."
    },
    "splits": {
        "unable_sync_tax": {
            "title": "Error",
            "message": "Unable to adjust tax as the split total percentage is not 100%"
        }
    },
    "table_fetch_failed": {
        "title": "A table failed to load",
        "message": "Please try loading the table again by clicking on the reload button."
    },
    "liquidity": {
        "deleted_scenario": {
            "title": "Error",
            "message": "Failed to delete a scenario."
        },
        "deleted_forecast_rule": {
            "title": "Error",
            "message": "Failed to delete a forecast rule."
        }
    },
    "download_spreadsheet_template": "Spreadsheet template download failed",
    "data_validation": "Data validation failed",
    "data_upload": "Data upload failed",
    "import_result_history": "Failed to get import history",
    "download_data_upload_result_log": "Log download failed",
    "transaction_category": {
        "order": {
            "title": "Error",
            "message": "Failed to update order of category."
        },
        "create": {
            "title": "Error",
            "message": "Failed to create transaction category."
        },
        "update": {
            "title": "Error",
            "message": "Failed to update transaction category."
        },
        "delete": {
            "title": "Error",
            "message": "Failed to delete transaction category."
        }
    },
    "update": {
        "title": "Error",
        "message": "Update failed"
    },
    "payment_method": {
        "update": {
            "title": "Error",
            "message": "Payment Method update failed."
        },
        "update_in_stripe": {
            "title": "Error",
            "message": "Payment method could not be processed. Please make sure data provided is correct or a try a different payment method."
        }
    },
    "expense_tag": {
        "create": {
            "title": "Create failed"
        },
        "delete": {
            "title": "Delete failed"
        },
        "attach": {
            "title": "Attach tag failed"
        },
        "detach": {
            "title": "Detach tag failed"
        }
    },
    "datev_online": {
        "missing_account_month": {
            "title": "Error",
            "message": "DUO export failed for at least one request as the accounting month is not configured in your DUO account."
        },
        "unsupported_file_type": {
            "title": "Error",
            "message": "You are trying to export a request with an invoice that contains an unsupported file format. Please try a different invoice file format e.g. .pdf, .png, .jpeg"
        },
        "account_not_found": {
            "title": "Error",
            "message": "Your DUO account couldn't be accessed. This can happen if you link it elsewhere, for example. We automatically disconnected the account - please connect in the settings."
        },
        "export_timeout": {
            "title": "Error",
            "message": "The DUO export could not be completed at the moment. Please try again later."
        },
        "damaged_invoice": {
            "title": "Error",
            "message": "You are trying to export a request with an invoice that is of a wrong file format. Please try a different invoice file."
        },
        "export_success": {
            "title": "Success",
            "message": "DUO export successfully processed."
        },
        "export_error": {
            "title": "Error",
            "message": "DUO export failed."
        },
        "export_partial": {
            "title": "Warning",
            "message": "DUO export failed for some requests."
        },
        "invalid_access_token": {
            "title": "Warning",
            "message": "DUO export failed for at least one request as the DATEV access token was missing. Please connect in the settings."
        }
    },
    "bulk_data_upload": {
        "download_report": "Failed to download report",
        "download_import": "Failed to download import file"
    },
    "vat": {
        "vat_rate_fetch": {
            "message": "Failed to load VAT rates."
        }
    },
    "outdated_version": {
        "title": "Warning",
        "message": "You version is outdated, please refresh the page in your browser."
    },
    "mfa": {
        "enforce": "Failed to enforce MFA",
        "deforce": "Failed to deforce MFA"
    },
    "sso": {
        "no_access": {
            "title": "Access blocked",
            "description": "You are not part of this organization. Make sure to contact your superior to receive an invitation for finway for this email address."
        },
        "toggle": "Connection wasn't de-/activated"
    },
    "ocr_error": "OCR Error",
    "profile": {
        "edit": {
            "title": "Edit failed",
            "message": "Failed to update profile."
        }
    },
    "datev_wallet_csv": {
        "title": "Attention - export incomplete",
        "message": "The \"Konto\" and/or \"Gegenkonto\" column has some empty cells, check the export settings or add missing creditors. If necessary, also add the client and consultant number."
    },
    "change_history": {
        "export": {
            "title": "Error",
            "message": "The change history could not be exported."
        }
    },
    "invoice": {
        "fetch_failed": {
            "message": "Failed to load invoice."
        }
    },
    "invoice_number": {
        "invalid_character": {
            "title": "Invalid characters on invoice number",
            "message": "Please check your input. Invisible characters and the following characters are not allowed: \"§°´"
        }
    },
    "featureFlag": {
        "p2p_order_not_enabled": {
            "title": "Purchase-2-Pay Module disabled",
            "message": "The Purchase-2-Pay module has been deactivated, therefore no purchase orders or delivery notes can be created. Please change the document type to “Invoice” in order to process it."
        }
    },
    "purchase_order": {
        "approve": {
            "title": "Approve failed"
        },
        "delete": {
            "title": "Error",
            "message": "Failed to delete purchase order."
        },
        "auto_match": {
            "title": "Auto-match failed",
            "message": "Failed to automatically match line items. Please try again or match manually."
        }
    },
    "delivery_note": {
        "delete": {
            "title": "Error",
            "message": "Failed to delete delivery note."
        }
    },
    "export": {
        "too_many_invoices_to_export_to_datev": {
            "title": "Error",
            "message": "The DUO export can not be performed because DUO only allows a maximum of 50 files per expense."
        }
    }
}
